<template>
  <div :class="panelClass">
    <slot></slot>
  </div>
</template>
<script>
import { PREFIX_CLASS } from '@/utils/constants'

export default {
  name: 'TTabPanel',
  props: {
    panelId: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      prefix: PREFIX_CLASS + 'tabs',
      show$: true
    }
  },
  computed: {
    panelClass() {
      return [
        `${this.prefix}-panel`,
        { 'active': this.show$ }
      ]
    }
  },
  watch: {
    disabled(val) {
      this.update()
    },
    panelId(val) {
      this.update()
    },
    label() {
      this.update()
    },
    icon() {
      this.update()
    }
  },
  mounted() {
    this.update()
  },
  methods: {
    update() {
      this.$parent.$emit('tabs-refresh')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/tabs/tabs-panel.vue